import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetContainer from "../FacetContainer";
import ConjunctiveFacetProduct from "./ConjunctiveFacetProduct";
export default class ConjunctiveFacet extends Component {
  render() {
    const FiltersLink = this.props.filtersLink;
    return /*#__PURE__*/React.createElement(FacetContainer, {
      facet: this.props.facet,
      facetProductComponentClass: ConjunctiveFacetProduct,
      filters: this.props.filters,
      filtersContext: this.props.filtersContext,
      filtersLink: FiltersLink,
      forceExpanded: this.props.forceExpanded,
      hiddenFilters: this.props.hiddenFilters,
      itemFactory: this.props.itemFactory,
      onFacetProductClick: this.props.onFacetProductClick,
      perspective: this.props.perspective,
      stateChangeRequested: this.props.stateChangeRequested
    });
  }
}
_defineProperty(ConjunctiveFacet, "propTypes", {
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  filtersContext: AddonDiscoveryPropTypes.filtersContext,
  filtersLink: PropTypes.func.isRequired,
  forceExpanded: PropTypes.bool,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});
_defineProperty(ConjunctiveFacet, "defaultProps", {
  forceExpanded: false
});